export class ILLGenericKeys {
    id: string;
    label: string;
    code: string;
    name: string;
    relatedKeys: ILLGenericKeys[];
    relatedKeyLabels: string;
}
